module.exports = __webpack_public_path__ + "assets/merriweather-regular.e26c30be5c602a320e0cf78e19fa01f6.woff";